import { render, staticRenderFns } from "./EditTemplateComponent.vue?vue&type=template&id=76fb8880&scoped=true&lang=pug"
import script from "./EditTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./EditTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./EditTemplateComponent.vue?vue&type=style&index=0&id=76fb8880&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb8880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fb8880')) {
      api.createRecord('76fb8880', component.options)
    } else {
      api.reload('76fb8880', component.options)
    }
    module.hot.accept("./EditTemplateComponent.vue?vue&type=template&id=76fb8880&scoped=true&lang=pug", function () {
      api.rerender('76fb8880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance/customerPortal/EditTemplateComponent.vue"
export default component.exports